import { Node, mergeAttributes } from '@tiptap/react';

export const ImageCaption = Node.create({
  name: 'imageCaption',

  group: 'block',

  content: 'text*',

  defining: true,

  isolating: true,

  marks: '',

  addAttributes() {
    return {
      hidden: {
        default: false,
      },
    };
  },

  onUpdate() {
    const {
      state: {
        selection: { $from },
      },
    } = this.editor;

    const node = $from.node();
    const nodeType = node.type.name;

    if (nodeType === this.name) {
      const isEmpty = !node.textContent.trim();
      const isHidden = node.attrs.hidden;

      if (this.editor.isEditable) {
        if (isEmpty && !isHidden) {
          this.editor.commands.updateAttributes(this.name, {
            hidden: true,
          });
        } else if (!isEmpty && isHidden) {
          this.editor.commands.updateAttributes(this.name, {
            hidden: false,
          });
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'figcaption',
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const isEmpty = !node.textContent.trim();
    const isEditMode = this.editor?.isEditable;

    const hideCaption =
      (!isEditMode && node.attrs.hidden) || (!isEditMode && isEmpty);

    return [
      'figcaption',
      mergeAttributes(HTMLAttributes, {
        class: `node-${this.name}${hideCaption ? ' hide' : ''}`,
      }),
      0,
    ];
  },

  addKeyboardShortcuts() {
    return {
      // On Enter at the end of line, create new paragraph and focus
      Enter: ({ editor }) => {
        const {
          state: {
            selection: { $from, empty },
          },
        } = editor;

        if (!empty || $from.parent.type !== this.type) {
          return false;
        }

        const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;

        if (!isAtEnd) {
          return false;
        }

        const pos = editor.state.selection.$from.end();

        return editor
          .chain()
          .focus(pos)
          .insertContentAt(pos, { type: 'paragraph' })
          .run();
      },
    };
  },
});

export default ImageCaption;
